import { SelectedTab, TabTypes } from '../../src/types';

export const mockSelectedTab = ({
  type = TabTypes.UPCOMING,
}: Partial<SelectedTab> = {}): SelectedTab => {
  return {
    type,
  };
};
